// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"d907ae7d","513":"5999d88f","703":"88c9716b","787":"dfa9e343"}[chunkId] + ".chunk.js";
};